import { useEffect, useState } from "react";

 
import slide2 from "../../assets/img/gallery/2s.jpg";
import slide3 from "../../assets/img/gallery/3s.jpg";
import slide4 from "../../assets/img/gallery/4s.jpg";
import gallery1 from "../../assets/img/gallery/gallery1.jpeg";
import gallery2 from "../../assets/img/gallery/gallery2.jpeg";
import gallery3 from "../../assets/img/gallery/gallery3.jpeg";
import gallery4 from "../../assets/img/gallery/gallery4.jpeg";
import gallery5 from "../../assets/img/gallery/gallery5.jpeg";
import gallery6 from "../../assets/img/gallery/gallery6.jpeg";
import gallery7 from "../../assets/img/gallery/gallery7.jpeg";
import gallery8 from "../../assets/img/gallery/gallery8.jpeg";
import gallery9 from "../../assets/img/gallery/gallery9.jpeg";
import gallery10 from "../../assets/img/gallery/gallery10.jpeg";
import gallery11 from "../../assets/img/gallery/gallery11.jpeg";
 
import gallery13 from "../../assets/img/gallery/gallery13.jpeg";
import gallery14 from "../../assets/img/gallery/gallery14.jpeg";
import gallery15 from "../../assets/img/gallery/gallery15.jpeg";
import gallery16 from "../../assets/img/gallery/gallery16.jpeg";
import gallery17 from "../../assets/img/gallery/gallery17.jpeg";
import gallery18 from "../../assets/img/gallery/gallery18.jpeg";
import gallery19 from "../../assets/img/gallery/gallery19.jpeg";
import gallery20 from "../../assets/img/gallery/gallery20.jpeg";
import gallery21 from "../../assets/img/gallery/gallery21.jpeg";
import gallery22 from "../../assets/img/gallery/gallery22.jpeg";
import gallery23 from "../../assets/img/gallery/gallery23.jpeg";
import gallery24 from "../../assets/img/gallery/gallery24.jpeg";
import gallery25 from "../../assets/img/gallery/gallery25.jpeg";
import gallery26 from "../../assets/img/gallery/gallery26.jpeg";
import gallery27 from "../../assets/img/gallery/gallery27.jpeg";
import gallery28 from "../../assets/img/gallery/gallery28.jpeg";
import gallery29 from "../../assets/img/gallery/gallery29.jpeg";
import gallery30 from "../../assets/img/gallery/gallery30.jpeg";
import gallery31 from "../../assets/img/gallery/gallery31.jpeg";
import gallery32 from "../../assets/img/gallery/gallery32.jpeg";
import gallery33 from "../../assets/img/gallery/gallery33.jpeg";
import gallery34 from "../../assets/img/gallery/gallery34.jpeg";
import gallery35 from "../../assets/img/gallery/gallery35.jpeg";
const Gallery = () => {
  const [filter, setFilter] = useState("all");
  const [previewImage, setPreviewImage] = useState(null);
  const [showFilteredImages, setShowFilteredImages] = useState(false);

  const images = [
    // { src: slide1, alt: "Oil 1", category: "oil" },
    { src: slide2, alt: "Cotton 1", category: "cottons" },
    { src: slide3, alt: "Oil 2", category: "cottons" },
    { src: slide4, alt: "Cotton 2", category: "cottons" },
    { src: gallery1, alt: "Cotton 1", category: "cottons" },
    { src: gallery2, alt: "Oil 1", category: "oil" },
    { src: gallery3, alt: "Cotton 2", category: "cottons" },
    { src: gallery4, alt: "Oil 2", category: "oil" },
    { src: gallery5, alt: "Cotton 3", category: "cottons" },
    { src: gallery6, alt: "Oil 3", category: "oil" },
    { src: gallery7, alt: "Cotton 4", category: "cottons" },
    { src: gallery8, alt: "Oil 4", category: "oil" },
    { src: gallery9, alt: "Cotton 5", category: "cottons" },
    { src: gallery10, alt: "Oil 5", category: "oil" },
    { src: gallery11, alt: "Cotton 6", category: "cottons" },
   
    { src: gallery13, alt: "Cotton 7", category: "cottons" },
    { src: gallery14, alt: "Oil 7", category: "oil" },
    { src: gallery15, alt: "Cotton 8", category: "cottons" },
    { src: gallery16, alt: "Oil 8", category: "oil" },
    { src: gallery17, alt: "Cotton 9", category: "cottons" },
    { src: gallery18, alt: "Oil 9", category: "oil" },
    { src: gallery19, alt: "Cotton 10", category: "cottons" },
    { src: gallery20, alt: "Oil 10", category: "oil" },
    { src: gallery21, alt: "Cotton 11", category: "cottons" },
    { src: gallery22, alt: "Oil 11", category: "oil" },
    { src: gallery23, alt: "Cotton 12", category: "cottons" },
    { src: gallery24, alt: "Oil 12", category: "oil" },
    { src: gallery25, alt: "Cotton 13", category: "cottons" },
    { src: gallery26, alt: "Oil 13", category: "oil" },
    { src: gallery27, alt: "Cotton 14", category: "cottons" },
    { src: gallery28, alt: "Oil 14", category: "oil" },
    { src: gallery29, alt: "Cotton 15", category: "cottons" },
    { src: gallery30, alt: "Oil 15", category: "oil" },
    { src: gallery31, alt: "Cotton 16", category: "cottons" },
    { src: gallery32, alt: "Oil 16", category: "oil" },
    { src: gallery33, alt: "Cotton 17", category: "cottons" },
    { src: gallery34, alt: "Oil 17", category: "oil" },
    { src: gallery35, alt: "Cotton 18", category: "cottons" }
    
  ];

  const filteredImages =
    filter === "all"
      ? images
      : images.filter((image) => image.category === filter);

  const handlePreview = (src) => {
    setPreviewImage(src);
  };

  const closeModal = (e) => {
    if (e.target === e.currentTarget) {
      setPreviewImage(null);
    }
  };

  // When the filter changes, we trigger the transition effect
  useEffect(() => {
    setShowFilteredImages(false);
    const timeout = setTimeout(() => {
      setShowFilteredImages(true);
    }, 500); // Delay to allow slide-in effect

    return () => clearTimeout(timeout);
  }, [filter]);

  return (
    <section className="we-work-skill-wrapper section-padding">
         <div className="row">
            <div className="col-xl-6 col-lg-8 mb-4 offset-xl-3 offset-lg-2 col-12 text-lg-center">
                <div className="section-title-4">
                    <h2> Our gallery</h2>
                </div>
            </div>
        </div>
      <div className="gallery">
        {/* <div className="filter">
                <button onClick={() => setFilter("all")}>All</button>
                <button onClick={() => setFilter("oil")}>Oil</button>
                <button onClick={() => setFilter("cottons")}>Cottons</button>
            </div> */}

        <div className="images">
          {filteredImages.map((image, index) => (
            <img
              key={index}
              src={image.src}
              alt={image.alt}
              className={`galleryItem ${showFilteredImages ? "show" : "hide"} ${
                showFilteredImages ? "filterIn" : ""
              }`}
            //   onClick={() => handlePreview(image.src)}
            />
          ))}
        </div>

        {previewImage && (
          <div className="modal show" onClick={closeModal}>
            <div className="modalContent">
              <img src={previewImage} alt="Preview" className="modalImage" />
              <span className="close" onClick={() => setPreviewImage(null)}>
                &times;
              </span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
